import React, { useEffect, useState } from 'react'
import Card from 'react-bootstrap/Card';
import GraphData from './GraphData';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormFieldSelect from '../../../Components/FormFields/FormFieldSelect';
import { BsCurrencyRupee, BsPeople } from 'react-icons/bs';
import { BiCalendar, BiDownArrowAlt, BiUpArrowAlt } from 'react-icons/bi';
import { AiOutlineMedicineBox } from 'react-icons/ai';
import { getDashboardStats } from '../../../Services/admin-service';
import { useDispatch } from 'react-redux';
import { showErrorToast } from '../../../Redux/slices/toastSlice';
import { printAmount } from '../../../Utils/helpers';


const AdminDashboard = () => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [statsData, setStatsData] = useState<any>({});

    const [statsType, setStatsType] = useState("all");

    const loadData = () => {
        setLoading(true);
        getDashboardStats({
            statsType
        }).then((res: any) => {
            setStatsData(res?.data);
        }).catch((err: any) => {
            dispatch(showErrorToast(err?.message));
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        loadData();
    }, [statsType]);

    console.log(statsData)
    return (
        <>
            <div className='dashboard_layout ml-0'>
                <div className="cardcontainer">

                    <Row>
                        <Col>
                            <div className="section-title section-title-5 left">
                                <h1>Dashboard</h1>
                            </div>
                        </Col>
                    </Row>

                    <Row className='mb-2'>
                        <Col md={2}>
                            <FormFieldSelect
                                id="gender"
                                name="gender"
                                label={false}
                                onChange={(e) => setStatsType(e?.target?.value ?? "")}
                                options={[
                                    { _id: "all", name: "All Time" },
                                    { _id: "weekly", name: "Weekly" },
                                    { _id: "monthly", name: "Monthly" },
                                    { _id: "yearly", name: "Yearly" }
                                ]}
                                value={statsType}
                                placeholder={"Select Duration Type"}
                            />
                        </Col>
                    </Row>

                    <Row gap={5}>
                        <Col md={3} sm={12}>
                            <Card className='stats-card'>
                                <Card.Body>
                                    <div className='card_dashboard'>
                                        <div className='icon'>
                                            <BsCurrencyRupee />
                                        </div>
                                        <div className="text_data">
                                            <p>Total Earnings</p>
                                            <h1>
                                                <span className="val">{printAmount(statsData?.totalEarnings)}</span>
                                            </h1>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={3} sm={12}>
                            <Card className='stats-card'>
                                <Card.Body>
                                    <div className='card_dashboard'>
                                        <div className='icon'>
                                            <AiOutlineMedicineBox />
                                        </div>
                                        <div className="text_data">
                                            <p>Doctors</p>
                                            <h1>
                                                <span className="val">{statsData?.totalDoctors}</span>
                                            </h1>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className='stats-card'>
                                <Card.Body>
                                    <div className='card_dashboard'>
                                        <div className='icon'>
                                            <BsPeople />
                                        </div>
                                        <div className="text_data">
                                            <p>Patients</p>
                                            <h1>
                                                <span className="val">{statsData?.totalPatients}</span>
                                            </h1>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card className='stats-card'>
                                <Card.Body>
                                    <div className='card_dashboard'>
                                        <div className='icon'>
                                            <BiCalendar />
                                        </div>
                                        <div className="text_data">
                                            <p>Total Appointments</p>
                                            <h1>
                                                <span className="val">{statsData?.totalAppointments}</span>
                                            </h1>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <GraphData statsType={statsType} data={statsData?.graph ?? null}/>
            </div>
        </>
    )
}

export default AdminDashboard